import axios from "axios";
import app from "./main";

axios.defaults.withCredentials = true;

const api2 = axios.create({
  baseURL: "https://staging.api.talentalt.com/",
  withCredentials: true,
  headers: {
    Accept: "multipart/form-data",
    "Content-Type": "multipart/form-data"
  }
});

api2.interceptors.request.use(config => {
  app.$Progress.start(); // for every request start the progress
  return config;
});

api2.interceptors.response.use(response => {
  app.$Progress.finish(); // finish when a response is received
  return response;
});

export default api2;
